export default {
  manual: 'Manual',
  filters: {
    status: 'Estado',
    event_type: 'Tipo de evento',
  },
  columns: {
    event: 'Evento',
    status: 'Estado',
    attempts: 'Intentos',
    last_http_status: 'Último estado HTTP',
    created_at: 'Creado',
  },
  statuses: {
    pending: 'Pendiente',
    delivered: 'Entregado',
    failed: 'Fallido',
  },
  buttons: {
    details: 'Detalles',
    resend: 'Reenviar',
  },
  detail: {
    title: 'Detalles de entrega',
    event: 'Evento',
    attempts: 'Intentos',
    no_attempts: 'Aún no hay intentos.',
    no_response: 'sin respuesta',
    payload: 'Carga útil',
  },
  toasts: {
    load_error: 'No se pudieron cargar las entregas.',
    resend_error: 'No se pudo reenviar la entrega.',
    resent: 'Entrega en cola para reenvío.',
  },
};
